import { addItem, getItems, updateItem, deleteItem } from './db';

let PaymentFormsTable = 'PaymentForms';

export async function savePaymentForms(data) {
    for await (const element of data) {
        await addItem(PaymentFormsTable, element, '_id');
    }
}

export async function getLocalPaymentForms() {
    return await getItems(PaymentFormsTable);
}